import { VerificationHomeQueryResults } from './useVerificationQuery/types';

const isCapitalDepositStepRequired = (data: VerificationHomeQueryResults) => {
  const {
    viewer: {
      company: { capitalDeposit, isCapitalDeposit },
    },
  } = data;
  if (
    isCapitalDeposit === false ||
    capitalDeposit === null ||
    capitalDeposit === undefined
  ) {
    return false;
  }
  const { status } = capitalDeposit;
  // If the form is in any other state, then the form must have been submitted
  // and is either being processed, is completed or is in a refused state
  // which should be caught by a higher level redirect.
  return status === 'INITIATED' || status === 'FORM_INVALID';
};

export default isCapitalDepositStepRequired;
